export enum EEX_PATHS {
  HOME = "https://newm.io/",
  FAQ = "https://newm.io/faq/",
  YOUTUBE = "https://www.youtube.com/@projectNEWM",
  LEARN_MORE_WALLETS = "https://docs.cardano.org/new-to-cardano/types-of-wallets",
  TWITTER = "https://twitter.com/projectNEWM",
}
